<!-- appDevTag="shared/components/chatbot/chatbot" -->
<div class="chatbot-wrapper" [class.minimized]="isMinimized" *ngIf="isOpen">
  <!-- HEADER -->
  <div class="chatbot-header" (click)="isMinimized ? toggleMinimize() : null" [style.cursor]="isMinimized ? 'pointer' : 'default'">
    <div class="chatbot-header-left">
      <img src="assets/Ricardo/icon.png" alt="Ricardo" class="chatbot-header-icon" width="60" height="60" />
      <div class="chatbot-header-info">
        <span class="chatbot-header-name">Ricardo</span>
      </div>
    </div>
    <div class="chatbot-header-actions">
      <button class="chatbot-header-btn" (click)="$event.stopPropagation(); toggleMinimize()" [title]="isMinimized ? 'Expandir' : 'Minimizar'">
        <img src="assets/Ricardo/seta1.png" alt="" class="minimize-arrow" [class.rotated]="isMinimized" width="24" height="14" />
      </button>
      <button class="chatbot-header-btn" (click)="$event.stopPropagation(); close()" title="Fechar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- BODY -->
  <div class="chatbot-body" *ngIf="!isMinimized" #chatBody>
    <!-- Ecrã de boas-vindas (zero mensagens) -->
    <div class="chatbot-welcome" *ngIf="messages?.length === 0">
      <h3 class="welcome-title">Olá! Sou o Ricardo 👋</h3>
      <p class="welcome-text">
        Assistente da Seguros Virtual.<br>
        Estou aqui para ajudar. Em que posso ser útil?
      </p>

      <!-- Indicador discreto de ligação -->
      <div class="welcome-connecting" *ngIf="isInitializing">
        <span class="connecting-dot"></span>
        <span class="connecting-text">A ligar...</span>
      </div>

      <div class="welcome-suggestions">
        <button
          class="suggestion-chip"
          [disabled]="isInitializing"
          (click)="sendQuickMessage('Quais os seguros disponíveis?')"
        >
          Seguros disponíveis
        </button>
        <button
          class="suggestion-chip"
          [disabled]="isInitializing"
          (click)="sendQuickMessage('Preciso de ajuda com uma apólice')"
        >
          Ajuda com apólice
        </button>
        <button
          class="suggestion-chip"
          [disabled]="isInitializing"
          (click)="sendQuickMessage('Informações sobre sinistros')"
        >
          Sinistros
        </button>
      </div>
    </div>

    <!-- Lista de mensagens -->
    <div class="chatbot-messages" *ngIf="messages?.length > 0">
      <div
        *ngFor="let msg of messages; trackBy: trackByIndex"
        class="chat-message"
        [class.chat-message-user]="msg.sender === 'user'"
        [class.chat-message-bot]="msg.sender === 'bot'"
      >
        <div class="chat-bubble" [class.bubble-user]="msg.sender === 'user'" [class.bubble-bot]="msg.sender === 'bot'">
          <span class="chat-text" [innerHTML]="formatMessage(msg.text)"></span>
          <div class="chat-meta">
            <span class="chat-time">{{ formatTime(msg.timestamp) }}</span>
            <span *ngIf="msg.sender === 'user' && msg.status === 'sending'" class="chat-status sending">
              <mat-icon class="status-icon">schedule</mat-icon>
            </span>
            <span *ngIf="msg.sender === 'user' && msg.status === 'sent'" class="chat-status sent">
              <mat-icon class="status-icon">done</mat-icon>
            </span>
            <span *ngIf="msg.sender === 'user' && msg.status === 'error'" class="chat-status error">
              <mat-icon class="status-icon">error_outline</mat-icon>
            </span>
          </div>
        </div>
      </div>

      <!-- Indicador de "a escrever" -->
      <div class="chat-message chat-message-bot" *ngIf="isLoading">
        <div class="chat-bubble bubble-bot typing-bubble">
          <div class="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Cards de produtos (visíveis enquanto não houver mensagens do utilizador) -->
    <div class="products-section" *ngIf="!isInitializing && !hasUserMessages && chatProducts?.length > 0">
      <div class="products-grid">
        <div
          class="product-card"
          *ngFor="let product of chatProducts; trackBy: trackBySlug"
          (click)="navigateToProduct(product)"
        >
          <div class="product-card-image">
            <img [src]="product.imageUrl" [alt]="product.name" loading="lazy" />
          </div>
          <button class="product-card-btn" (click)="$event.stopPropagation(); navigateToProduct(product)">
            <img [src]="product.buttonUrl" [alt]="'Simular ' + product.name" loading="lazy" />
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- FOOTER / INPUT -->
  <div class="chatbot-footer" *ngIf="!isMinimized">
    <div class="chatbot-input-container">
      <input
        #messageInput
        type="text"
        class="chatbot-input"
        [(ngModel)]="currentMessage"
        (keydown.enter)="$event.preventDefault(); sendMessage()"
        placeholder="Escreva a sua mensagem..."
        [disabled]="isLoading || isInitializing"
        maxlength="500"
        autocomplete="off"
        enterkeyhint="send"
      />
    </div>
    <button
      class="chatbot-send-btn"
      (click)="sendMessage()"
      [disabled]="!currentMessage?.trim() || isLoading || isInitializing"
      [class.active]="currentMessage?.trim() && !isLoading"
    >
      <img src="assets/Ricardo/botao.png" alt="Enviar" />
    </button>
  </div>
</div>
